"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _a, _b;
var definitions_1 = require("./definitions");
exports.references = (_a = {}, _a[definitions_1.RangeReferencePoint.DATE_NOW] = function () {
  return new Date();
}, _a[definitions_1.RangeReferencePoint.DATE_TODAY_START] = function () {
  var d = new Date();
  d.setUTCHours(0, 0, 0, 0);
  return d;
}, _a[definitions_1.RangeReferencePoint.DATE_WEEK_START] = function () {
  var d = new Date();
  d.setUTCHours(0, 0, 0, 0);
  d.setUTCHours(-24 * d.getUTCDay());
  return d;
}, _a[definitions_1.RangeReferencePoint.DATE_MONTH_START] = function () {
  var d = new Date();
  d.setUTCDate(1);
  d.setUTCHours(0, 0, 0, 0);
  return d;
}, _a[definitions_1.RangeReferencePoint.DATE_YEAR_START] = function () {
  var d = new Date();
  d.setUTCMonth(0, 1);
  d.setUTCHours(0, 0, 0, 0);
  return d;
}, _a);
exports.unitTransforms = (_b = {}, _b[definitions_1.RangeReferenceUnit.HOURS] = function (reference, value) {
  return reference.setUTCHours(reference.getUTCHours() + value);
}, _b[definitions_1.RangeReferenceUnit.DAYS] = function (reference, value) {
  return reference.setUTCDate(reference.getUTCDate() + value);
}, _b[definitions_1.RangeReferenceUnit.WEEKS] = function (reference, value) {
  return reference.setUTCDate(reference.getUTCDate() + value * 7);
}, _b[definitions_1.RangeReferenceUnit.MONTHS] = function (reference, value) {
  var currentDate = reference.getUTCDate();
  var date = reference.setUTCMonth(reference.getUTCMonth() + value);
  var prevDate = reference.getUTCDate();
  // The expected behaviour is to jump, in months units, to the same date
  // if the date does not exist in the previous/next month/s, e.g. 31st February
  // we jump to the end of the month, e.g. 28th February
  // so we check if is possible to jump to the same date,
  if (currentDate === prevDate) {
    return date;
  }
  // if not, we jump to the end of the month
  return reference.setUTCDate(0);
}, _b[definitions_1.RangeReferenceUnit.YEARS] = function (reference, value) {
  var currentDate = reference.getUTCDate();
  var date = reference.setUTCFullYear(reference.getUTCFullYear() + value);
  var prevDate = reference.getUTCDate();
  // The expected behaviour is to jump, in years units, to the same date
  // if the date does not exist in the previous/next year/s, e.g. 29th February
  // we jump to the end of the month, e.g. 28th February
  // so we check if is possible to jump to the same date,
  if (currentDate === prevDate) {
    return date;
  }
  // if not, we jump to the end of the month
  return reference.setUTCDate(0);
}, _b);
var RangeUtil = /** @class */function () {
  function RangeUtil() {}
  RangeUtil.convert = function (value) {
    var refValue = value;
    if (refValue.reference) {
      var reference = exports.references[refValue.reference]();
      // as we don't need unit if value is 0 so return reference itself
      if (refValue.value === 0) {
        return reference.valueOf();
      }
      if (refValue.unit) {
        return exports.unitTransforms[refValue.unit](reference, refValue.value);
      }
    }
    return refValue.value;
  };
  /** @deprecated use convert instead */
  RangeUtil.unwrap = function (value) {
    return this.convert(value);
  };
  RangeUtil.validate = function (rangeReference) {
    var hasInvalidValue = function () {
      return typeof rangeReference.value !== 'number';
    };
    var hasInvalidReference = function () {
      return rangeReference.hasOwnProperty('reference') && !Object.values(definitions_1.RangeReferencePoint).includes(rangeReference.reference);
    };
    var hasInvalidUnit = function () {
      return rangeReference.hasOwnProperty('unit') && !Object.values(definitions_1.RangeReferenceUnit).includes(rangeReference.unit);
    };
    var hasInvalidUnitAndReferenceCombo = function () {
      if (rangeReference.value !== 0) {
        return rangeReference.reference && !rangeReference.unit || !rangeReference.reference && rangeReference.unit;
      }
      return false;
    };
    if (hasInvalidValue()) {
      throw new Error('Range value is not valid');
    } else if (hasInvalidReference()) {
      throw new Error('Range reference is not valid');
    } else if (hasInvalidUnit()) {
      throw new Error('Range unit is not valid');
    } else if (hasInvalidUnitAndReferenceCombo()) {
      throw new Error('Range unit and reference both are required if value !== 0');
    }
    return true;
  };
  return RangeUtil;
}();
exports.RangeUtil = RangeUtil;